export default "__VITE_ASSET__DWFPluhr__"